import { auto } from '@popperjs/core';

export default (theme) => ({
    root: {
        boxSizing: 'border-box',
        padding: '0px 16px 16px 16px',
        display: 'flex',
        flexDirection: 'column',
        gap: 8,
    },
    chat: {
        flex: 1,
        overflowX: 'hidden',
        boxSizing: 'border-box',
        borderRadius: 6,
        ...theme.utils.scrollbar,

        '& .dana-chat-conversation': {
            width: '100%',
        },
        '& [class*="CopilotChat__root"]': {
            marginTop: 0,
        },
    },
    input: {
        marginTop: auto,
    },
});
